import { get } from 'lodash'
import { useQuery } from 'react-query'
import hooks from '../../../hooks'

const useCourseDropability = ({
    courseId
}) => {

    const { api, endpoints, url } = hooks.useApi()
    const { id: userId } = hooks.useCurrentUser()
    const cacheKeys = hooks.useCacheKeys()

    const { data, isLoading } = useQuery(
        [cacheKeys.COURSES, courseId, 'dropability'],
        () => api.get(url(endpoints.userCourseDropability, { courseId, userId })),
        {
            enabled: userId && courseId
        }
    )

    return {
        isLoadingDropability: isLoading,
        dropable: get(data, 'dropable', false),
        reason: get(data, 'reason')
    }
}

export default useCourseDropability
